import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { TagStyled as Tag } from 'petco-ui/elements/text/tag/Tag.styled';

const modifiers = {
  withBorders: ({ theme, level }) => ({
    styles: `
      border-radius: 4px;
      border: 1px solid ${theme.primary.darkYellow};
      background-color: ${level === 'warning' ? theme.primary.transparentYellow : theme.status[level].light};
      padding:  0.25rem 0.5rem;
      font-size: 0.75rem;
      line-height: 1.25rem;

      .Text {
        color: ${theme.primary.darkYellow};
      }
    `,
  }),
};

export const TagStyled = styled(Tag).attrs({
  className: 'Tag',
})`
  border-radius: 0;
  background-color: ${({ theme, level }) => theme.status[level].light};
  padding: 0.5rem;

  .Text {
    color: ${({ theme, level }) => theme.status[level].main};
    display: inline-block;
  }

  ${applyStyleModifiers(modifiers)}
`;
